import { LegalLayout, LegalSection } from "@/components/kaje/Legal";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="January 2026" testId="privacy-page">
      <LegalSection heading="1. Who We Are">
        <p>
          KAJE is an Australian software development business operated as a sole trader by Justin
          Kingaby (ABN 13 907 721 664). KAJE designs, develops and delivers mobile applications
          and digital products, including consumer-focused apps featuring AI-powered technology,
          interactive experiences and digital subscription services.
        </p>
      </LegalSection>

      <LegalSection heading="2. Information We Collect">
        <p>
          When you submit the contact form on this website, we collect your name, email address,
          project category and the contents of your message. We use this information solely to
          respond to your enquiry and to conduct business with you.
        </p>
      </LegalSection>

      <LegalSection heading="3. How We Use Information">
        <p>
          Information you provide is used only to communicate with you about your enquiry, prepare
          proposals, and deliver services. We do not sell, rent or share your personal information
          with third parties for marketing purposes.
        </p>
      </LegalSection>

      <LegalSection heading="4. Data Storage & Security">
        <p>
          Enquiry data is stored securely and retained only for as long as needed to manage our
          business relationship and meet legal obligations. Reasonable technical measures are in
          place to protect it from unauthorised access.
        </p>
      </LegalSection>

      <LegalSection heading="5. Your Rights">
        <p>
          Under the Australian Privacy Act 1988 (Cth), you may request access to, or correction
          of, the personal information we hold about you. To make a request, contact us via the
          contact form on this website.
        </p>
      </LegalSection>

      <LegalSection heading="6. Contact">
        <p>
          For privacy questions, contact Justin Kingaby via the contact form on this website.
          Direct email:{" "}
          <a href="mailto:kajebiz.store@gmail.com" className="text-emerald-700 font-semibold hover:underline" data-testid="privacy-email-link">
            kajebiz.store@gmail.com
          </a>
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
